
import { Vue, Component, Prop } from "vue-property-decorator";

import ModalFullScreen from "@/components/modal/ModalFullScreen.vue";
import ModalSectionsDivider from "@/components/modal/ModalSectionsDivider.vue";
import UiButton from "@/components/button/ui-button.vue";

import GET_SUBSCRIPTION_BASIC_INFO from "@/apollo/payment/GetSubscriptionBasicInfo.gql"
import UPDATE_SUBSCRIPTION_BASIC_INFO_STATE from "@/apollo/payment/UpdateSubscriptionBasicInfoState.gql"

import RouteParams from "@/entities/RouteParams";
import RouteNames from "@/entities/RouteNames";
import { allowedAccessSubscriptionStatuses } from "@/data/subscriptionStatus";
import { Company, Subscription } from "@/generated/graphql";
import { User } from "@/interface";

interface SubscriptionDetails {
  managersCount: number,
  subscriptionPlanName: string,
}

@Component({
  apollo: {
    subscription: {
      query: GET_SUBSCRIPTION_BASIC_INFO,
      variables() {
        return {
          companyId: this.company.id,
          activeStatuses: allowedAccessSubscriptionStatuses,
        };
      },
      update(data) {
        return data.subscription[0];
      },
    },
  },
  components: {
    ModalFullScreen,
    ModalSectionsDivider,
    UiButton,
  },
})
export default class SubscriptionBasicInfoModal extends Vue {
  @Prop({ type: Object, required: true }) readonly company!: Company;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;

  subscription: Subscription | null = null;

  get details(): SubscriptionDetails {
    const subscriptionPlan = this.subscription!.subscription_plan;

    return {
      subscriptionPlanName: subscriptionPlan.name!,
      managersCount: subscriptionPlan.subscription_plan_access_permission!.managers_count,
    };
  }


  get loading(): boolean {
    return this.$apollo.queries.subscription.loading;
  }

  get pricingRoute(): RouteParams<{}> {
    return {
      name: RouteNames.PRICING,
    };
  }

  async mounted(): Promise<void> {
    await this._updateModalState();
  }

  private async _updateModalState(): Promise<void> {
    await this.$apollo.mutate({
      mutation: UPDATE_SUBSCRIPTION_BASIC_INFO_STATE,
      variables: {
        adminId: this.currentUser.admin.id,
      },
    });
  }

  openPricingPage(): void {
    this.$router.push(this.pricingRoute);
  }
}
